import { setNewbuildingIdInStorage } from './setNewbuildingIdInStorage';
import { PHONE_SHOWED_STORAGE_KEY } from '../../constants/lastHopePopup';

export function setUserOpenedPhoneInNewobject(newobjectId: number): void {
  setNewbuildingIdInStorage(PHONE_SHOWED_STORAGE_KEY, newobjectId);
}
